import React from "react";
import { Outlet } from "react-router";

import { SYSTEM_ADMIN_PATH } from "../../../../constants";

const Licensees = React.lazy(() => import('.'));

const routes = {
     path: SYSTEM_ADMIN_PATH.LICENSEES,
     breadcrumb: 'Licensees',
     element: <Outlet />,
     children: [
          { index: true, element: <Licensees /> },
     ]
};

export default routes;
